// extracted by mini-css-extract-plugin
module.exports = {"root":"_1EUgg","bg":"RQOgo","arrow":"_3KIwU"};